import { render, staticRenderFns } from "./tab1.vue?vue&type=template&id=0dd314f6&scoped=true&"
import script from "./tab1.vue?vue&type=script&lang=js&"
export * from "./tab1.vue?vue&type=script&lang=js&"
import style0 from "./tab1.vue?vue&type=style&index=0&id=0dd314f6&prod&scoped=true&lang=scss&"
import style1 from "./tab1.vue?vue&type=style&index=1&id=0dd314f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd314f6",
  null
  
)

export default component.exports